import {
    SYMBOL_GROUPS_FETCH,
    SYMBOL_GROUPS_IS_FETCHING,
    SYMBOL_GROUP_FILTER,
    SYMBOL_GROUP_EDIT,
} from 'constants/symbolGroups'

export default function symbolGroupsReducer(state = {
    list: [],
    pageable: {
        sort: {
            'symbolGroupId': false,
            'name': 'asc',
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case SYMBOL_GROUPS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case SYMBOL_GROUP_EDIT:
            return {
                ...state,
            }
        case SYMBOL_GROUPS_IS_FETCHING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case SYMBOL_GROUP_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/symbolGroups.js